const BASE_URL = 'https://api.dev.auxo.dk/public';

export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/content/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchBySlug(lang, slug) {
  try {
    const response = await fetch(`${BASE_URL}/by-slug/${lang}/${slug}`);
    if (!response.ok) throw new Error(`Failed to fetch slug: ${slug}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function submitCmsEntry(collectionName, data) {
  const response = await fetch(`${BASE_URL}/submissions/${collectionName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const resJson = await response.json().catch(() => ({}));
  if (!response.ok) {
    const errorMsg = resJson.message || 'Der skete en fejl ved indsendelse. Prøv venligst igen.';
    const err = new Error(errorMsg);
    err.details = resJson;
    throw err;
  }
  return resJson;
}
